import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  dashboard: "/dashboard-financial",
};

export const fetchDashboardFinancial = createAsyncThunk(
  "dashboard-financial/fetchDashboardFinancial",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.dashboard, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        // Tipagem explícita para backend
        const backend = error.response?.data as {
          message?: string;
          errors?: any;
        };

        return thunkAPI.rejectWithValue({
          message: backend?.message || "Erro desconhecido.",
          errors: backend?.errors || {},
        });
      }

      return thunkAPI.rejectWithValue({
        message: "Erro inesperado.",
        errors: {},
      });
    }
  },
);
